import type { FC } from 'react';
import React from 'react';

import LoaderOverlay from '../../../../../../../common/components/LoaderOverlay';
import { DataHook } from '../../../../../../../types';
import styles from './Loader.scss';

export const Loader: FC = () => {
  return <LoaderOverlay dataHook={DataHook.Loader} className={styles.loader} />;
};
